<template>
    <div class="content-box">
        <Title/>
        <div class="title-right">
      <!-- <el-link href="https://www.100ec.cn/Index/wjsqdws.html" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/dd.gif"
      /></el-link> -->
      <!-- <el-link href="https://www.100ec.cn/detail--6649722.html" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/2024kjbqb.gif"
      /></el-link> -->
      
    </div> 
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(i, index) of dataNav"
            :key="index"
            @click="handleSelect(index)">
            {{i.label}}</el-menu-item>
        </el-menu>

        <div class="mobile-select">
            <el-select
            v-model="name"
            @change="handleSelect2">
                <el-option
                v-for="item in dataNav"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "broadCast",
    data() {
        return {
            activeIndex: '1',
            name: '滚动播报',
            dataNav: [
                {
                    value: 3,
                    label: '滚动播报'
                },
                {
                    value: '海淘',
                    label: '海淘'
                },
                {
                    value: '数字贸易',
                    label: '数字贸易'
                },
                {
                    value: '独立站',
                    label: '独立站'
                },
                {
                    value: '跨境 物流',
                    label: '跨境物流'
                },
                {
                    value: '海外仓 跨境',
                    label: '海外仓'
                },
                {
                    value: '邮政 跨境',
                    label: '邮政'
                },
                {
                    value: '跨境 支付',
                    label: '跨境支付'
                },
                {
                    value: '国务院 跨境',
                    label: '国务院'
                },
                {
                    value: '海关 跨境',
                    label: '海关'
                },
                {
                    value: '商务部 跨境',
                    label: '商务部'
                },
                {
                    value: '综试区 跨境',
                    label: '综试区'
                },
                {
                    value: 'eWTP',
                    label: 'eWTP'
                },
                {
                    value: 'RCEP',
                    label: 'RCEP'
                },
                {
                    value: '广交会',
                    label: '广交会'
                },
                {
                    value: '进博会',
                    label: '进博会'
                },
                {
                    value: '出海',
                    label: '出海'
                },
                {
                    value: 'FBA',
                    label: 'FBA'
                },
                {
                    value: 'D2C',
                    label: 'D2C'
                },
                {
                    value: '浅析 跨境',
                    label: '浅析'
                },
                {
                    value: '实战 跨境',
                    label: '实战'
                },
                {
                    value: '案例 跨境',
                    label: '案例'
                },
                {
                    value: '研报 跨境',
                    label: '研报'
                },
                {
                    value: '盘点 跨境',
                    label: '盘点'
                },
                {
                    value: '分析 跨境',
                    label: '分析'
                },
                {
                    value: 'PPT 跨境',
                    label: 'PPT'
                },
                {
                    value: '信息图 跨境',
                    label: '信息图'
                },
                {
                    value: '口岸',
                    label: '口岸'
                },
            ],
            params: {
                json: 2,
                filter: [
                    '张周平',
                    '曹磊',
                    '莫岱青',
                    '蒙慧欣',
                    '李鹏博',
                    '朱秋城',
                    '林智勇',
                    '吕友臣',
                    '刘俊斌'
                ]
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', this.dataNav[0].value)
        this.$store.dispatch('getText')
        
    },
    methods: {
        handleSelect(index) {
            if(typeof(this.dataNav[index].value) == 'number') {
                this.params.json = 2
            }else {
                this.params.json = 0
            }
            this.$store.commit('textparams', this.params)
            this.$store.commit('changeKeys', this.dataNav[index].value)
            this.$store.dispatch('getText')
        },
        handleSelect2(value) {
            if(typeof(value) == 'number') {
                this.params.json = 2
            }else {
                this.params.json = 0
            }
            this.$store.commit('textparams', this.params)
            this.$store.commit('changeKeys', value)
            this.$store.dispatch('getText')
        },
    },
}
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>